export const API_BASE_URL = process.env.REACT_APP_BASE_URL || process.env.REACT_APP_PA_FASTAPI_URL || process.env.REACT_APP_API_URL || 'https://pa-fastapi.payairo.com';
